// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"6b8e9d71","558":"251cff37","739":"61133690","817":"2c0ff8be","889":"57b859c9","917":"413a1723"}[chunkId] + ".chunk.css";
};